<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1" id="_idContainer002">
<div class="_idGenObjectStyle-Disabled" id="_idContainer003"><a id="_idTextAnchor000"></a>
<img alt="" class="_idGenObjectAttribute-1" src="image/ban_pud_back_cc.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer004">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mary_Mac_Final_epub.vue?68463b1f